import { useState } from 'react';
import classNames from 'classnames';

import {
  SectionTitle,
  Tab,
  TabContent,
  TabContentItem,
  TabPanel,
  Tabs,
  TextBlock,
} from '@/ui/index';

import styles from './Documents.module.scss';

const Documents = ({ data }) => {
  const [activeTab, setActiveTab] = useState(0);

  const renderTab = (item, index) => {
    return (
      <Tab
        className={classNames([
          styles.tab,
          { [styles.active]: activeTab === index },
        ])}
        onClick={() => {
          setActiveTab(index);
        }}
        key={item?.id}
      >
        {item?.title}
      </Tab>
    );
  };

  const renderTabContent = (item) => {
    return (
      <>
        <SectionTitle className={styles.title} titleModify='title--large'>
          {item?.title}
        </SectionTitle>

        <TextBlock className={styles.text} isHtml>
          {item?.content}
        </TextBlock>
      </>
    );
  };

  return (
    <div
      className='wrapper section'
      itemScope
      itemType='https://schema.org/Property'
    >
      {data?.tabs?.length > 0 && (
        <Tabs active={activeTab}>
          <TabPanel className={styles.tabToggles}>
            {data.tabs.map(renderTab)}
          </TabPanel>
          <TabContent>
            {data.tabs.map((item) => (
              <TabContentItem
                className={styles.activeTabContentItem}
                active={activeTab === item?.id}
                key={item?.id}
              >
                {renderTabContent(item)}
              </TabContentItem>
            ))}
          </TabContent>
        </Tabs>
      )}
    </div>
  );
};
export default Documents;
